import { ScaleDirection } from './../resize-helper';
import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { Plane2Model } from '../../../model';
import { Ng3CornerResizeEvent, CornerDirection } from '../resize-helper';
import { CanvasService } from '../../../components/canvas.service';
import { EntityDragEvent } from '../../mouse/mouse-entity.service';

@Component({
  selector: 'ng3-resize-plane-corner',
  templateUrl: './resize-plane-corner.component.html',
  styleUrls: ['./resize-plane-corner.component.css'],
})
export class ResizePlaneCornerComponent implements OnInit, OnDestroy {
  @Input() model: Plane2Model | undefined;
  @Input() direction: CornerDirection = { x: 'right', y: 'top' };
  @Input() z = 1;
  @Output() resize = new EventEmitter<Ng3CornerResizeEvent>();
  constructor(private canvas: CanvasService) {}

  ngOnInit() {
    if (this.model === undefined) {
      throw Error('Model is not provided');
    }
  }
  ngOnDestroy() {}
  setStyle(isHover: boolean) {
    this.canvas.domElement.style.cursor = isHover ? this.cursorStyle() : 'auto';
  }
  private cursorStyle() {
    if (this.direction.x === 'left' && this.direction.y === 'top') {
      return 'nwse-resize';
    }
    if (this.direction.x === 'right' && this.direction.y === 'top') {
      return 'nesw-resize';
    }
    if (this.direction.x === 'left' && this.direction.y === 'bottom') {
      return 'nesw-resize';
    }
    if (this.direction.x === 'right' && this.direction.y === 'bottom') {
      return 'nwse-resize';
    }
    throw Error('Invalid corner direction');
  }
  onDrag(e: EntityDragEvent, direction: CornerDirection) {
    this.resize.emit({
      type: 'corner',
      direction: this.direction,
      to: e.relativeCenter,
    });
  }
}
export enum CursorStyle {
  Default = 'default',
  Move = 'move',
  Auto = 'auto',
  EWResize = 'ew-resize',
  NSResize = 'ns-resize',
  NESWResize = 'nesw-resize',
  NWSEResize = 'nwse-resize',
}
